<template>
    <div id="container" class="container">
        <myheader2 name="作品登记"></myheader2>
        <div class="main-page-outer min-width">
            <div class="mx1360 main-count2 flex-r">
                <div class="left-cont">
                    <centerNavBar name="作品登记"></centerNavBar>
                </div>
                <div class="right-cont">
                    <div class="collect-form">
                        <collectedit ref="collectForm" />
                    </div>
                </div>
            </div>
        </div>
        <myfooter2></myfooter2>
    </div>
</template>

<script>
let that;
import ty from "@/utils/ty/ty";
import util from "@/common/util.js"
import collectedit from "../components/collectForm.vue";
export default {
    components: {
        collectedit
    },
    data() {
        return {
            pickerOptions: {
                shortcuts: [{
                    text: '昨天',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
                        end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '今天',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        // start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }],
            },
            value2: '',

            options: [{
                value: '选项1',
                label: '黄金糕'
            }, {
                value: '选项2',
                label: '双皮奶'
            }, {
                value: '选项3',
                label: '蚵仔煎'
            }, {
                value: '选项4',
                label: '龙须面'
            }, {
                value: '选项5',
                label: '北京烤鸭'
            }],
            value: '',
            baseInfo: {
                cnt1: 0,
                cnt2: 0,
                cnt3: 0,

            },
            partnerlist: [],
        }
    },
    created() {
        that = this;
    },
    mounted() {
        that.initData();
        that.$refs['collectForm'].formShow();
    },
    methods: {
        addcollect() { },
        goPage(path) {
            util.tourl(path)
        },
        initData() {
            ty.ajax('web/web/indexs', {}).then((result) => {
                that.baseInfo.cnt1 = result.data.cnt1;
                that.baseInfo.cnt2 = result.data.cnt2;
                that.baseInfo.cnt3 = result.data.cnt3;
                that.partnerlist = result.data.data
            });
        }
    },
};
</script>

<style lang="scss">
@import '../../style.scss'; //所有页面公用
@import '../../style2.scss'; //所有页面公用
@import './workRegistration.scss';
</style>